import { dutyProgress, type DutyCheckpoint } from "./duty-progress";

// Duty-home progress panel (ship-dark behind web_duty_home). Mirrors the native patrol-home
// feel: a quiet headline, a checkpoint list with proof-green ticks for what's been captured
// this session. The honesty subtitle is part of the design, not décor — this panel is the
// guard's working memory, the console stays the record.

export function DutyProgress({
  checkpoints,
  capturedIds,
}: {
  checkpoints: readonly DutyCheckpoint[];
  capturedIds: ReadonlySet<string>;
}) {
  const model = dutyProgress(checkpoints, capturedIds);
  return (
    <section className="dutyhome" aria-label="Session progress">
      <div className="dutyhome__head">
        <h2 className={`dutyhome__headline${model.complete ? " dutyhome__headline--complete" : ""}`}>
          {model.headline}
        </h2>
        <p className="dutyhome__scope">Session progress — resets when the app reloads. The console keeps the record.</p>
      </div>
      {model.total > 0 ? (
        <ul className="dutyhome__list">
          {model.rows.map((row) => (
            <li
              key={row.checkpointId}
              className={`dutyhome__row${row.captured ? " dutyhome__row--captured" : ""}`}
            >
              <span className="dutyhome__tick" aria-hidden="true">
                {row.captured ? "✓" : ""}
              </span>
              <span className="dutyhome__label">{row.label}</span>
              {row.captured ? <span className="dutyhome__sr">captured this session</span> : null}
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
